import getIn from '../components/connectedForm/utils/getIn';

export default (rowData, path = 'product') => {
  const product = getIn(rowData, path);
  return product?.precision || 0;
};
